import SocialEntityRepository from '@/shared/http/repositories/socialProject/social-entity'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import SocialEntity from '@/shared/models/socialEntity'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'NovaEntidadeSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Entidade Social',
    socialEntity: new SocialEntity(),
    isNew: true
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Entidades Sociais',
            href: this.$router.resolve({ name: 'SocialEntity' }).href
          },
          {
            text: 'Nova Entidade Social',
            active: true
          }
        ]
      }
    }
  },

  methods: {
    create(socialEntity) {
      loading.push()
      SocialEntityRepository.Create(socialEntity)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Entidade Social criada com sucesso', 'NOVA ENTIDADE SOCIAL')
          Promise.resolve()
          return this.$router.replace({ name: 'SocialEntity' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao criar entidade social', 'ERRO')
        })
    }
  }
}
